export default __webpack_public_path__ + "static/media/GRANOS.ecc58dde.png";